import { Monitor, Moon, Sun } from "lucide-react";
import { useIntl } from "react-intl";
import { type Theme, useTheme } from "../../hooks/use-theme.js";
import { Button } from "../ui/button.js";

const NEXT: Record<Theme, Theme> = {
  system: "light",
  light: "dark",
  dark: "system",
};

const ICONS: Record<Theme, typeof Sun> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
};

export function ThemeToggle() {
  const intl = useIntl();
  const { theme, setTheme } = useTheme();
  const Icon = ICONS[theme];
  const label = intl.formatMessage({ id: `theme.${theme}` });

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setTheme(NEXT[theme])}
      aria-label={`${intl.formatMessage({ id: "theme.label" })}: ${label}`}
      title={label}
    >
      <Icon size={18} />
    </Button>
  );
}
